<template>
  <v-footer padless dark>
    <v-container class="mb-16 px-0">
      <v-row>
        <v-col cols="12" lg="6">
          <v-card flat color="transparent">
            <v-card-title>About Platinum Auto Shop</v-card-title>
            <v-card-text>
              Welcome to Platinum Auto website. Whether you are our past, current, or
              future customers; this page will guide you with precious information related to car's
              market price, specification, and knowledge. We strongly hope that our shop will
              provide you with quality cars, reasonable price, and premium services as well as match
              the cars with your needs.
            </v-card-text>
          </v-card>
        </v-col>
        <v-col cols="12" lg="6">
          <v-card color="transparent" flat>
            <v-card-title>Links</v-card-title>
            <v-card-text>
              <div>
                <router-link to="/" class="white--text" style="text-decoration: none;"
                  >Home</router-link
                >
              </div>
              <div class="mt-2">
                <router-link to="/privacy-policy" class="white--text" style="text-decoration: none;"
                  >Privacy Policy</router-link
                >
              </div>
              <div class="mt-2">
                <router-link to="/support" class="white--text" style="text-decoration: none;"
                  >Support</router-link
                >
              </div>
              <div class="mt-2">
                <router-link to="/contact" class="white--text" style="text-decoration: none;"
                  >Contact Us</router-link
                >
              </div>
            </v-card-text>
          </v-card>
        </v-col>
        <!-- <v-col cols="12" lg="3">
          <v-card color="transparent" flat>
            <v-card-title>Download Mobile Apps</v-card-title>
            <v-card-text>
              <v-img
                max-width="172"
                contain
                :src="require('../assets/downloadonappstore.png')"
              ></v-img>
              <v-img
                class="mt-4"
                max-width="172"
                contain
                :src="require('../assets/getitongoogleplay.png')"
              ></v-img>
            </v-card-text>
          </v-card>
        </v-col> -->
      </v-row>
    </v-container>
  </v-footer>
</template>

<script>
export default {}
</script>
